import { Box, TextField, InputAdornment, Stack } from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";

const PageToolbar = ({
  searchTerm,
  onSearchChange,
  searchPlaceholder = "Search...",
  hideSearch = false,
  actionButtons,
  children,
}) => {
  return (
    <Stack
      direction={{ xs: "column", md: "row" }}
      spacing={2}
      alignItems={{ xs: "stretch", md: "center" }}
      justifyContent="space-between"
      sx={{ mb: 3 }}
    >
      {/* LEFT SIDE: Search + Dynamic Filters */}
      <Stack
        direction={{ xs: "column", sm: "row" }}
        spacing={2}
        sx={{ width: "100%", maxWidth: { md: "75%" } }}
      >
        {!hideSearch && (
          <TextField
            placeholder={searchPlaceholder}
            variant="outlined"
            size="small"
            value={searchTerm}
            onChange={onSearchChange}
            sx={{ minWidth: { xs: "100%", sm: 250 } }}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <SearchIcon color="action" />
                </InputAdornment>
              ),
            }}
          />
        )}
        {children}
      </Stack>

      {/* RIGHT SIDE: Actions */}
      <Box
        sx={{
          display: "flex",
          justifyContent: { xs: "flex-start", md: "flex-end" },
          minWidth: "fit-content",
        }}
      >
        {actionButtons}
      </Box>
    </Stack>
  );
};

export default PageToolbar;
